import { Project } from "interfaces";

import Tag from "ui-components/Tag";

import { NotebookAnalysisProject } from "flows/notebook-analysis/interfaces";

const DataFileSummary = ({ project }: { project: Project }) => {
  const metaData = (project as NotebookAnalysisProject).meta_data;

  return (
    <div className="m-1">
      <div className="flex flex-wrap items-center">
        <span className="font-semibold">
          {metaData["notebook-counts"].length} Notebooks:
        </span>{" "}
        {metaData["notebook-counts"].map(({ notebook }) => (
          <Tag key={notebook}>{notebook}</Tag>
        ))}
      </div>

      <p className="font-semibold mt-2">Unit Operations:</p>
      <div className="mx-2">
        {Object.keys(metaData["unit-ops-sizes"])
          .sort(
            (a, b) =>
              metaData["unit-ops-sizes"][b] - metaData["unit-ops-sizes"][a]
          )
          .map((u) => (
            <p key={u}>
              {u}: {metaData["unit-ops-sizes"][u]} experiments
            </p>
          ))}
      </div>
    </div>
  );
};

export default DataFileSummary;
